<template><div>
  <h1 class="fdd-md--h1">fd-tabs-link</h1>
<h2 class="fdd-md--h2">Props</h2>
<h3 class="fdd-md--h3">uid</h3>
<p class="fdd-md--p"><strong>Type:</strong> <code>String</code></p>
<p class="fdd-md--p"><strong>Default:</strong> <code>–</code></p>
<h3 class="fdd-md--h3">active</h3>
<p class="fdd-md--p"><strong>Type:</strong> <code>Boolean</code></p>
<p class="fdd-md--p"><strong>Default:</strong> <code>–</code></p>
<h3 class="fdd-md--h3">disabled</h3>
<p class="fdd-md--p"><strong>Type:</strong> <code>Boolean</code></p>
<p class="fdd-md--p"><strong>Default:</strong> <code>–</code></p>
<h2 class="fdd-md--h2">Slots</h2>
<h3 class="fdd-md--h3">default</h3>

  </div></template>
  <script>
  export default {
    mixins: [{
 data() {
  return {
    fddComponentApi: {"componentDesc":{"default":[]},"name":"fd-tabs-link","props":[{"name":"uid","type":"String","describe":[]},{"name":"active","type":"Boolean","describe":[]},{"name":"disabled","type":"Boolean","describe":[]}],"slots":[{"name":"default","describe":"","backerDesc":"","bindings":{},"scoped":false,"target":"template"}]}
  };
 }
}
]
  }
  </script>
  